// extracted by mini-css-extract-plugin
export default {"deprecated-tag":"FootprintStatus_deprecated-tag__C6llu","draft-tag":"FootprintStatus_draft-tag__6kg95","published-tag":"FootprintStatus_published-tag__1ydq9"};